import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ExternalUserLinkOf360Component } from './external-user-link-of360/external-user-link-of360.component';
import { ElcmCondidateFromComponent } from './elcm-condidate-from/elcm-condidate-from.component';
import { WelcomeMessageComponent } from './welcome-message/welcome-message.component';
import { AutoLoginComponent } from '../auto-login/auto-login.component';
import { EvaluationFormComponent } from '../hradmin/recruitment/evaluation/evaluation-form/evaluation-form.component';
import { ExternalCandidateComponent } from '../hradmin/recruitment/external-candidate/external-candidate.component';
import { EmployeeSatisfactionSurveyComponent } from './employee-satisfaction-survey/employee-satisfaction-survey.component';
const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'auto-login',
    component: AutoLoginComponent
  },
  {
    path: 'set-new-password',
    component: SetNewPasswordComponent
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'externaluserlink',
    component: ExternalUserLinkOf360Component
  },
  {
    path: 'elcmform',
    component: ElcmCondidateFromComponent
  },
  {
    path: 'essform',
    component: EmployeeSatisfactionSurveyComponent
  },
  { 
    path:'evaluation', 
    component:EvaluationFormComponent
  },
  { 
    path:'candidate', 
    component:ExternalCandidateComponent
  },
  {
    path:'welcome',
    component:WelcomeMessageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
